import type { Signer } from "@cef-ai/signer";
import { provisioning } from "@cef-ai/account";

export interface EnsureProvisionedOpts {
  chainUrl: string;
  gateway: string;
  proxyType?: "Any" | "NonTransfer" | "Governance" | "Staking";
  delay?: number;
  /** Test seam: inject a provisioning impl. Production uses the real one. */
  _provisioning?: { ensure: typeof provisioning.ensure };
}

/**
 * Submit the on-chain `proxy.addProxy` that DDC onboarding needs, using the
 * passkey wallet's chain Signer. Run this BEFORE `vault.ensure({onboard:false})`
 * so the SDK never has to drive the old embed-wallet onboarding path.
 */
export async function ensureProvisioned(
  signer: Signer,
  opts: EnsureProvisionedOpts,
): Promise<{ txHash: string; ok: boolean }> {
  const impl = opts._provisioning ?? provisioning;
  return impl.ensure({
    signer,
    chainUrl: opts.chainUrl,
    gateway: opts.gateway,
    // 'NonTransfer' matches @cef-ai/account 2.0.0's new minimum-authority
    // default: the gateway only ever dispatches DdcCustomers create/remove-
    // bucket calls, neither of which is a transfer, so granting transfer
    // rights by default was needless authority. The gateway accepts both
    // spellings; pass `proxyType: 'Any'` explicitly to restore the old
    // broad grant.
    proxyType: opts.proxyType ?? "NonTransfer",
    delay: opts.delay,
  });
}
